export default {
  label: 'Tipo de Publicación',
  placeholder: 'Todos',
  items: {
    all: 'Todos',
    organic: 'Orgánico',
    boosted: 'Impulsado',
  },
};
